'use strict';

var _ = require('lodash');
var DateRangeChartDataProviderService = function DateRangeChartDataProviderService($filter, dataRetrieverService, constantsService, representationService, featureToggleService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  function errorRespond() {
    return {
      data: [],
      originalDepartureDates: []
    };
  }

  /**
   * Transforms the data loaded from the server into chart's format.
   * @param data - the data downloaded from the server, can be limited due to applied filters
   * @param dataRepresentation - 'absolute' or 'percentage' representation mode
   * @param departureDates - the original dates before applying the filters
   * @param postDepartureMode - post departure mode trigger
   * @returns {*}
   */
  function transformData(data, dataRepresentation, departureDates, postDepartureMode, metric) {
    if (data === undefined) {
      return errorRespond();
    }
    var result = [];
    var originalDepartureDates = _.chain(data).map('departureDateMoment').sortBy().value();
    departureDates = departureDates || originalDepartureDates;
    var lastProcessedDate = departureDates.length > 0 && departureDates[0].subtract(1, 'days');
    var dataMap = _.reduce(data, function (retValue, item) {
      retValue[item.departureDateMoment.valueOf()] = item;
      return retValue;
    }, {});
    _.forEach(departureDates, function (date) {
      if (!date.subtract(1, 'days').isSame(lastProcessedDate, 'day') && result.length > 0) {
        var gapMoment = lastProcessedDate.add(1, 'days');
        result.push(createNewItem(gapMoment, true, false));
      }
      var itemForDate = dataMap[date.valueOf()];
      var item = itemForDate || createNewItem(date, false, true);
      item.stackLabel = rmMomentFormat(date, 'DATE_ISO');
      lastProcessedDate = date;
      result.push(metric === 'loadFactor' ? representationService.prepareLFChartBarMetricsInAbsolute(item, dataRepresentation, postDepartureMode) : representationService.prepareChartBarMetrics(item, dataRepresentation, postDepartureMode));
    });
    return {
      data: result,
      originalDepartureDates: originalDepartureDates
    };
  }
  function createNewItem(moment, gap, hidden) {
    return {
      departureDateMoment: moment,
      isGap: gap,
      isHidden: hidden,
      tiles: []
    };
  }
  function getRetrieverMode(screen, mode, postDepartureMode) {
    var retrieverMode = mode;
    if (screen === constantsService.FLIGHT_SCREEN) {
      retrieverMode = featureToggleService.isDisabled('REVENUE_OPTIMIZER') ? constantsService.CABIN_DA_MODE : constantsService.CABIN_MODE;
      if (postDepartureMode) {
        retrieverMode = constantsService.CABIN_POST_DEPARTURE_MODE;
      }
    }
    return retrieverMode;
  }
  function getData(params) {
    var retrieverMode = getRetrieverMode(params.screen, params.mode, params.postDepartureMode);
    return dataRetrieverService.getDataRetriever(params.screen, retrieverMode).updateAdditionalParameters({
      selectedReference: params.selectedReference
    }).retrieveComponentData('date-range-level-chart', params.metric).then(function (data) {
      return transformData(data, params.dataRepresentation, params.departureDates, params.postDepartureMode, params.metric);
    }, function () {
      return errorRespond();
    });
  }
  return {
    getData: getData
  };
};
DateRangeChartDataProviderService.$inject = ['$filter', 'DataRetrieverService', 'DataRetrieverConstantsService', 'DataRepresentationService', 'FeatureToggleService'];
module.exports = DateRangeChartDataProviderService;